var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowPointingToRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.524,
    height: 15.5,
    viewBox: "0 0 22.524 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13846",
    d: "m.307 48.926 6.7-6.7A1.047 1.047 0 1 1 8.491 43.7l-4.915 4.919h17.9a1.047 1.047 0 1 1 0 2.095h-17.9l4.914 4.914a1.047 1.047 0 0 1-1.481 1.481l-6.7-6.7a1.047 1.047 0 0 1-.002-1.483z",
    transform: "translate(0 -41.916)",
    style: {
      fill: "#333"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointingToRight);
export default __webpack_public_path__ + "static/media/arrow-pointing-to-right.43a1ce6ac5570575fd30c65e56f2466e.svg";
export { ForwardRef as ReactComponent };